import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

export abstract class AccountValidators {
  static readonly NIP_PATTERN = /^\d{10}$/;
  static readonly MIN_PASSWORD_LENGTH = 8;
  static readonly MAX_PASSWORD_LENGTH = 32;
  static readonly USERNAME_PATTERN = /^[a-zA-Z0-9_.]+$/;
  static readonly MIN_CREDENTIALS_NAME_LENGTH = 4;
  static readonly POST_CODE_PATTERN = /^[0-9]{2}-[0-9]{3}$/;
}

export abstract class ClientSecretsValidators {
  static readonly CLIENT_ID_PATTERN = /^\s*[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\s*$/;
  static readonly CLIENT_SECRET_PATTERN = /^\s*[0-9a-f]{64}\s*$/;
}

/**
 * Zwraca walidator pola opartego na wzorcu, ale tylko jeśli pole zostało wypełnione.
 * @param pattern Wyrażenie regularne
 */
export function patternIfFilledValidator(pattern: RegExp): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    return pattern.test(control.value)
      ? null
      : { pattern: { value: control.value } };
  };
}
